import { useLazyQuery } from '@apollo/client';
import { useState, useEffect, useCallback } from 'react';
import { IOption } from '../../../types/common';
import Typeahead from './typeahead';
import { IPositionTitle, IPositionTitleResponse } from '../../../types/position';
import { POSITION_TITLES } from '../../../graphql/position-gql';
import { messages } from '../../../i18n/message';
import { LOCALES } from '../../../i18n/locales';
import { IOrg } from '../../../types/org';

type PositionTypeaheadProps = {
    org?:IOrg;
    positionTitleSelected: (positionTitle: IPositionTitle | null) => void;
    init: IPositionTitle;
    validate:(error:string)=>void;
    elementId:string;
    limit?:number;
    isRole:boolean;
    disabled?:boolean;
    autoFocus?:boolean;
}

const PositionTypeahead = (props: PositionTypeaheadProps) => {
    const {org, positionTitleSelected,init,validate,elementId,limit,isRole,disabled=false,autoFocus } = props
    const [positionTitleOpts, setPositionTitleOpts] = useState<IOption[]>([])
    const [selectedPositionTitle, setSelectedPositionTitle] = useState<IOption>()
    const [findPositionTitles, { loading, data: positionTitlesResp }] = useLazyQuery<IPositionTitleResponse>(POSITION_TITLES,
        {
            fetchPolicy:'network-only',
            onCompleted: (data) => {
                onValidate(data);
            }
        }
    )
    const [error,setError] = useState<string>('');

    useEffect(()=>{
        setSelectedPositionTitle({id:init.positionTitleId,label:init.positionName});
    },[init])

    useEffect(() => {
        if (positionTitlesResp?.positionTitles && positionTitlesResp?.positionTitles.length > 0) {
            setPositionTitleOpts(positionTitlesResp.positionTitles.map((e: IPositionTitle) => ({id: e.positionTitleId, label: e.positionName})))
        } else {
            setPositionTitleOpts([])
        }
    }, [positionTitlesResp])

    useEffect(() => {
        validate(error);
    }, [error])

    const onValidate = useCallback((data:IPositionTitleResponse)=>{
        if ((data?.positionTitles && data?.positionTitles.length > 0))
            setError('')
        else
            setError(messages[LOCALES.ENGLISH].ERROR['5611'])
    },[])

    const queryPosition = useCallback((str: string) => {
        findPositionTitles({
            variables: {
                input:str,
                limit:limit||20,
                categoryId: org?.details.category.id||0
            }
        })
    }, [])

    const selectPositionTitle = useCallback((opt: IOption) => {
        setSelectedPositionTitle(opt)
        let pos = positionTitlesResp?.positionTitles.find(e => e.positionTitleId === opt?.id)
        positionTitleSelected(pos ? pos : null)
    }, [positionTitlesResp])

    const onBlur = () =>{
        setError('');
    }

    return (
        <div >
            <Typeahead
                placeHolder={`Begin typing to search ${isRole?'role':'position'} titles`}
                options={positionTitleOpts}
                value={selectedPositionTitle}
                loading={loading}
                query={queryPosition}
                onSelected={selectPositionTitle}
                id={elementId}
                onBlur={onBlur}
                error = {error}
                disabled={disabled}
                autoFocus={autoFocus}
            />
        </div>
    )
}

export default PositionTypeahead
